import _ from 'lodash';
import api from '@/api';
import { getField, updateField } from 'vuex-map-fields';

const state = () => ({
  query: {
    order_by: 'created_at',
    dir: 'asc',
    page: 1,
  },
  pagination: {
    data: [],
    current_page: 1,
    last_page: 1,
    path: null,
    per_page: 15,
    total: 0,
    from: null,
    to: null,
    first_page_url: null,
    last_page_url: null,
    next_page_url: null,
    prev_page_url: null,
  },
  fetching: false,
  preference: null,
  choices: {
    order: [
      { text: 'Created At', value: 'created_at' },
      { text: 'Updated At', value: 'updated_at' },
    ],
  },
});

const getters = {
  getField,
  items: (state) => _.get(state, 'pagination.data', []),
};

const actions = {
  fetch: function(context) {
    context.commit('applyFetching', true);
    const promise = api.preference.fetch(context.state.query);
    promise
      .then((response) => {
        context.commit('applyFetched', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  delete(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.preference.delete(uuid);
    promise
      .then((response) => {})
      .catch((e) => {})
      .then(() => {});

    return promise;
  },
  show: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.preference.show(uuid);
    promise
      .then((response) => {
        context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  publish: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.preference.subscribe(uuid);
    promise
      .then((response) => {
        context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  unpublish: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.preference.unsubscribe(uuid);
    promise
      .then((response) => {
        context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  // cancel: function(context) {
  //   context.commit('instance/applyResetInstance', false);
  // },
};

const mutations = {
  updateField,

  applyFetching: function(state, status) {
    state.fetching = status;
  },
  applyFetchedSingle: function(state, preference) {
    state.preference = preference;
  },
  applyFetched: function(state, data) {
    state.pagination = data;
  },
};

const modules = {
  // instance: instance,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules,
};
